import { useStaticQuery, graphql } from 'gatsby';

type TArticle = {
  author: string;
  id: string;
  title: string;
  url: string;
  description: string;
  categories: string[];
  publishedTime: string;
  modifiedTime: string;
  updatedTime: string;
  content: string;
  tags: string[] | null;
};

type TLatestFourNewsItemsQuery = {
  allNewsYaml: {
    articles: {
      article: TArticle;
    }[];
  };
};

const useLatestFourNewsItems = () => {
  const { allNewsYaml } = useStaticQuery<TLatestFourNewsItemsQuery>(
    graphql`
      query LatestFourNewsItems {
        allNewsYaml(sort: { publishedTime: DESC }, limit: 4) {
          articles: edges {
            article: node {
              author
              id
              title
              url
              description
              categories
              publishedTime
              modifiedTime
              updatedTime
              content
              tags
            }
          }
        }
      }
    `,
  );

  const flattened = allNewsYaml.articles.reduce((acc, item) => {
    acc = [...acc];

    return [
      ...acc,
      {
        ...item.article,
      },
    ];
  }, [] as TArticle[]);

  return flattened;
};

export { useLatestFourNewsItems };
export type { TArticle };
